import { Box, Flex, Icon } from '@energiebespaarders/symbols';
import { CaretDown, CaretUp } from '@energiebespaarders/symbols/icons/line';
import { useRouter } from 'next/router';
import { useState } from 'react';
import theme from '~/styles/theme';
import type { getCategories_allFaqCategories } from '~/types/generated/cms/getCategories';
import { NewLink } from './SubNavbar';

interface Props {
  readonly categories: ReadonlyArray<getCategories_allFaqCategories>;
}

const MobileSubNavbar: React.FC<Props> = ({ categories }) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  const router = useRouter();
  const pathnames = router.asPath.split('/');
  return (
    <Flex
      flexDirection="column"
      px={[2, 2, 4]}
      py={1}
      width={1}
      style={{
        background: theme.colors.grayLighter,
        fontSize: theme.type.scale[4],
        fontWeight: 400,
      }}
    >
      <Flex py={1} alignItems="center">
        <Box style={{ fontWeight: 500 }}>Vraag en Antwoord</Box>
        <Icon
          onClick={() => setExpanded(!expanded)}
          icon={expanded ? CaretUp : CaretDown}
          width="1em"
          ml={1}
        />
      </Flex>
      {expanded &&
        categories.map(c => {
          const isCurrent = pathnames.includes(c.title!.toLowerCase());
          return (
            <Box key={c.id} py={1} style={{ fontWeight: 500 }}>
              <NewLink to={`/faq/${c.slug}`} $isCurrent={isCurrent}>
                {c.title}
              </NewLink>
            </Box>
          );
        })}
    </Flex>
  );
};

export default MobileSubNavbar;
